import { render, staticRenderFns } from "./apiDocument.vue?vue&type=template&id=68203a76&scoped=true&"
import script from "./apiDocument.vue?vue&type=script&lang=js&"
export * from "./apiDocument.vue?vue&type=script&lang=js&"
import style0 from "./apiDocument.vue?vue&type=style&index=0&id=68203a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68203a76",
  null
  
)

export default component.exports